<template>
  <v-dialog
    v-model="internalValue"
    max-width="1100px"
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card>

      <!-- HEADER -->
      <v-card-title class="history-header">
        <v-icon left color="white">mdi-chart-timeline-variant</v-icon>
          Historial de Tasas Aplicables
        <v-spacer />
      </v-card-title>

      <v-divider />

      <!-- TABLE -->
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="data"
          item-key="id"
          dense
          class="elevation-0"
        >

          <template v-slot:[`item.fecha`]="{ item }">
            {{ formatDateShortText(item.fecha) }}
          </template>

          <template v-slot:[`item.tasa`]="{ item }">
            {{ formatRate(item.tasa) }}%
          </template>

          <template v-slot:[`item.interestAdditional`]="{ }">
            {{ formatRate(interestAdditional) }}%
          </template>

          <template v-slot:[`item.total`]="{ item }">
            {{ formatRate(parseFloat(item.tasa) + interestAdditional) }}%
          </template>

        </v-data-table>
      </v-card-text>

      <v-divider />

      <!-- FOOTER -->
      <v-card-actions class="justify-space-between px-4">
        <span class="caption grey--text text--darken-1 font-italic">
            Fuente: BANXICO.
        </span>

        <v-btn text color="primary" @click="close">
            Cerrar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import productMixin from '../../mixins/productMixin'

export default {
  name: 'RateHistory',
  mixins: [productMixin],
  props: {
    value: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
    interestAdditional: { type: Number, default: 0 }
  },

  data () {
    return { }
  },

  methods: {
    close () {
      this.internalValue = false
    }
  },

  computed: {
    internalValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    headers () {
      const base = [
        { text: 'Fecha', value: 'fecha', align: 'center' },
        { text: 'Tasa', value: 'tasa', align: 'center' }
      ]

      if (this.interestAdditional) {
        base.push(
          { text: 'Puntos adicionales', value: 'interestAdditional', align: 'center' },
          { text: 'Total', value: 'total', align: 'center' }
        )
      }

      return base
    }
  }
}
</script>

<style scoped>
.link-like {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.history-header {
  background: #324A74;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 16px 20px;
  letter-spacing: .4px;
  display: flex;
  align-items: center;
}
</style>
